import * as React from 'react';
import { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faChevronDown, faChevronUp, faMicrophone, faHourglassHalf, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { ConfirmModal, DABBackToList, EditableDropdown, LoadingSpinnerModal } from '../../components/dab';
import { Button, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { readingPlanAction } from '../../actions/readingPlanAction';
import { showAlert } from "../common/functions";
import { bibleAction } from '../../actions/bibleAction';
import moment from 'moment';
import { readingAction } from '../../actions/readingAction';


interface IReadingPlanProps {
	dispatch: Dispatch<any>;
	readingPlanData: any;
	bibleData: any;
	readingData: any;
	callback: any;
	id: number;
}


const ReadingPlanDetail: React.SFC<IReadingPlanProps> = ({
	dispatch, readingPlanData, bibleData, id, callback, readingData }) => {

	const history = useHistory();

	const initialBibleObject = [{ text: "", value: -1, checked: false, uniqueCode:"" }];
	const initialInputValue = {
		readingPlanId: -1,
		pageNumber: 1,
		pageSize: 10,
		sortColumn: "",
		sortDirection: "desc"
	};

	const [selectedDay, setSelectedDay] = useState(-1)
	const [selectedMonth, setSelectedMonth] = useState(-1)
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [isBibleListLoaded, setIsBibleListLoaded] = useState(false);
	const [isReadingListLoaded, setIsReadingListLoaded] = useState(false); 
	const [bibleList, setBibleList] = useState(initialBibleObject);
	const [readingList, setReadingList] = useState(initialBibleObject);
	const [formSubmit, setformSubmit] = useState(false);
	const [tempList, setTempList] = useState(false);
	const [year, setYear] = useState(0)
	const [confirmModal, setConfirmModal] = useState(false);
	const [readingIndex, setReadingIndex]=useState(0)
	const [readingObj, setReadingObj] = useState({
		bibleId: 0,
		channelId: 0,
		dayId:0,
		day: 0,
		month: 0,
		readingId: 0,
		readingPlanId: 0,
		readingTitle: ""	})
	const [isDirty, setIsDirty] = useState<boolean>(false)
	const [showDeleteModal, setShowDeleteModal] = useState(false);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		})
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronDown} />
			}
		}
	}

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div' onClick={(e) => { handleSort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	React.useEffect(() => {
		if (!isBibleListLoaded) {
			const initBibleInputValue = {
				languageCodes: [] as string[],
				uniqueCodes: [] as string[],
				pageNumber: 1,
				pageSize: 100,
				sortColumn: "",
				sortDirection: "asc",
				isCommonFilter: false,
				isLanguageFilter: false
			};
			dispatch(bibleAction.bibleGetByFilter(initBibleInputValue));
		}
		if (id > 0) {
			setFilterInput({
				...filterInput,
				readingPlanId: id,
			});
			var readingPlan = window.localStorage.getItem('readingPlan');
			if (readingPlan && readingPlan !== null) {
				const data = JSON.parse(readingPlan);
				callback(data.title + " " + data.year);
			}
		}
	}, []);

	React.useEffect(() => {
		if (id > 0 && filterInput.readingPlanId >= 0) {
			dispatch(readingPlanAction.readingPlanGetDetail(filterInput));
			setShowModal(true);
		}
	}, [filterInput]);

	if (showModal && !readingPlanData.isLoading) {
		if (readingPlanData.isListSuccess) {
			setYear(readingPlanData.inputs.year)
			readingPlanData.isListSuccess = false;
			setShowModal(false);
			var total: number = readingPlanData.totalDaysCount;
			var pList: number[] = [];
			if (total > 10) {
				for (var i = 1; i <= (total / 10); i++) {
					pList.push(i);
				}
				if ((total % 10) > 0) {
					pList.push((parseInt((total / 10).toString()) + 1));
				}
			}
			else {
				pList.push(1);
			}

		}		
	}

	if (bibleList && !isBibleListLoaded) {
		if (bibleData.items.length > 0) {
			var list: any[] = [];
			list.push({ text: "", value: -1, checked: false });
			bibleData.items.sort((a: any, b: any) => a.title?.localeCompare(b.title)).forEach((data) => {
				var item = { text: data.title + " (" + data.uniqueCode + ")", value: data.bibleId, checked: true };
				list.push(item);
			});
			setBibleList(list);
			setIsBibleListLoaded(true);
		}
	}

	if (readingList && !isReadingListLoaded) {
		if (readingData.items.length > 0) {
			var list1: any[] = [];
			list1.push({ text: "", value: -1, checked: false });
			readingData.items.map((data) => {
				list1.push({ text: data.title, value: data.title, checked: true });
			});
			setReadingList(list1);
			setIsReadingListLoaded(true);
		}
	}

	if (bibleList && !isBibleListLoaded) {
		if (bibleData.items.length > 0) {
			var list2: any[] = [];
			list2.push({ text: "", value: -1, checked: false });
			bibleData.items.map((data) => {
				list2.push({ text: data.title, value: data.bibleId, checked: true, uniqueCode: data.uniqueCode});
			});
			setBibleList(list2);
			setIsBibleListLoaded(true);
		}
	}

	const handleChangeText = (e, object, index: number, key) => {
		let value = e.target.value;
		// capture the previous title before overwriting, to detect the first letter typed into an empty field
		const previousTitle = object ? object.readingTitle : null;
		if (object && object !== null) {
			object[key] = value;
			if (key === "readingTitle") {
				object.readingId = -1;
			}
			readingPlanData.detailItems[index] = object;
			setTempList(!tempList);
		}
		if (key === "bibleId" && value > 0) {
			dispatch(readingAction.radingTitleGetExcludeByBible({ bibleIds: [value] }));
		}
		// fetch the title list for the row's selected bible only when the first letter is typed after clearing
		if (key === "readingTitle" && !previousTitle && value && value.length === 1 && object && object.bibleId > 0) {
			dispatch(readingAction.radingTitleGetExcludeByBible({ bibleIds: [String(object.bibleId)] }));
		}
		setIsDirty(true)
	}

	// hasChanges lets callers pass a change made in the same event, before the isDirty state update is applied
	const handleReadingSubmit = (e, object, index, hasChanges: boolean = isDirty) => {
		// EditableDropdown's onSelect passes a plain { target } object without preventDefault
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		if (!hasChanges) {
			return;
		}
		// skip the required reading text validation for a row with no reading and no translation selected
		if ((object.readingTitle === null || object.readingTitle === "") && !(parseInt(object.bibleId) > 0)) {
			return;
		}
		const filter = readingList.filter((text) => text === object.readingTitle)
		if (filter.length <= 0 && object.readingId<=0 && object.readingTitle != "" && object.readingTitle != null) {
			setConfirmModal(true);
			setReadingIndex(index);
			setReadingObj(object);
			// the confirm modal now handles this change, so the blur fired when focus returns to the input does not submit it again
			setIsDirty(false)
		} else {
			if (object && object !== null) {
				if (object.episodeId > 0) {
					showAlert("Cannot update a reading plan day that has an episode.", true)
					return
				}
				if (object.readingTitle !== null && object.readingTitle !== "" && object.bibleId >= 0) {
					readingPlanData.detailItems[index] = object;
					setformSubmit(true);
					setShowModal(true);
					object.bibleId = parseInt(object.bibleId);
					dispatch(readingPlanAction.readingPlanDaySave({ readingPlanDay: object }));
					setIsDirty(false)
				} else {
					showAlert("Please enter reading text", true)
				}
			}
		}
	}

	const handleReadingDelete = (e, object, index) => {
		if (object.episodeId > 0) {
			showAlert("Cannot delete the reading plan day with an episode.", true)
			return;
		}
		e.preventDefault();
		setReadingIndex(index);
		setReadingObj(object);
		setShowDeleteModal(true)
	}

	const handleDeleteModal = (value: boolean) => {
		if (value) {
			setShowModal(true);
			dispatch(readingPlanAction.readingPlanDayDelete(readingObj.dayId));
		}
		setShowDeleteModal(false);
	};

	if (readingPlanData) {
		if (readingPlanData.isSuccess && !readingPlanData.isError) {
			callback(readingPlanData.inputs.channelTitle + " " + readingPlanData.inputs.year);
		}
		if (readingPlanData.isSuccess && readingPlanData.isDeleteCompleted && !readingPlanData.isError) {
			showAlert(readingPlanData.status, false);
			readingPlanData.isDeleteCompleted = false;
			dispatch(readingPlanAction.readingPlanGetDetail(filterInput));
			readingPlanData.detailItems[readingIndex] = "";
			setShowModal(false);
		}

		if (!readingPlanData.isSuccess && readingPlanData.isError) {
			readingPlanData.isError = false;
			if (readingPlanData.status === 'Unauthorized') {
				history.push("/401");
			} else {
				showAlert(readingPlanData.status, true);
			}
			if (showModal) {
				setShowModal(false);
			}
		}

		if (formSubmit && readingPlanData.isSuccess && readingPlanData.isDayValueUpdateComplete) {
			readingPlanData.isDayValueUpdateComplete = false;
			if (readingPlanData.isSuccess) {
				showAlert(readingPlanData.status, false);
				if (readingPlanData.readingDayResult && readingPlanData.readingDayResult !== null) {
					var res = readingPlanData.readingDayResult;
					var ind = readingPlanData.detailItems.findIndex(x => x.day === res.day && x.month === res.month);
					readingPlanData.detailItems[ind].dayId = res.dayId;
					readingPlanData.detailItems[ind].bibleId = res.bibleId;
					readingPlanData.detailItems[ind].readingId = res.readingId;
					readingPlanData.detailItems[ind].episodeId = res.episodeId;
				}
			}
			if (showModal) {
				setShowModal(false);
			}
		}
		
	}

	if (readingData.isTitleListSuccess) {
		readingData.isTitleListSuccess = false;
		if (readingData.items.length > 0) {
			var list1: any[] = [];
			var strlist: any[] = [];
			list1.push({ text: "", value: -1, checked: false });
			readingData.items.forEach((data) => {
				var item = { text: data.title, value: data.title, checked: true };
				list1.push(item);
				strlist.push(data.title);
			});
			setReadingList(strlist);
		}
		setIsReadingListLoaded(true);
		if (showModal) {
			setShowModal(false);
		}
	}

	if (bibleData && bibleData.isSearch && bibleData.isSuccess) {
		bibleData.isSearch=false		
		if (bibleData.readingText != "" && bibleData.readingText != null) {			
			readingPlanData.detailItems[readingIndex] = readingObj;
			setformSubmit(true);
			setShowModal(true);			
			dispatch(readingPlanAction.readingPlanDaySave({ readingPlanDay: readingObj }));			
		} else {
			showAlert("Reading not found", true)
		}
		setShowModal(false)
	}


	const handleBackClick = (event) => {
		event.preventDefault();
		sessionStorage.removeItem("createEpisode")
		window.location.href = "/readingplan";
	}

	const handleCreateEpisode = (data) => {
		sessionStorage.removeItem("Filter");
		sessionStorage.removeItem("fromPage");
		var episode = { date: "", channelId: -1, episodeTypeCode: "reading"}
		episode.date = moment(`${year}/${data.month}/${data.day}`).format('YYYY-MM-DD')
		episode.channelId = data.channelId
		sessionStorage.setItem("createEpisode", JSON.stringify(episode))
		window.location.href = "/episode?page=add";
	}

	const handleTranslationSearch = (e) => {
		e.preventDefault();
		const bible = bibleList.filter((data: any) => data.value == readingObj.bibleId)
		setShowModal(true);
		setConfirmModal(false);
		dispatch(bibleAction.bibleTranslationSearch(readingObj.readingTitle, bible[0].uniqueCode))
	}

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	return (
		<div className="reading-plan-detail">
			<div>
				<DABBackToList onClick={(e) => { handleBackClick(e); }} />
				<div className='card-box'></div>
				<table className="table table-hover text-center">
					<thead>
						<tr>
							<th scope="col" data-testid="RPdayMonthHeader" className="reading-month">{handleGetSortColumn("Month", "MONTH")}</th>
							<th scope="col" data-testid="RPDayHeader" className="reading-day">Day</th>
							<th scope="col"data-testid="RPdayTranslationHeader">{handleGetSortColumn("Translation", "TRANSLATION")}</th>
							<th scope="col"data-testid="RPdayReadingHeader">Reading</th>
							<th scope="col"data-testid="RPdayViewReadingHeader">View Reading</th>
							<th scope="col" data-testid="RPdayEpisodeHeader">Episode</th>
						</tr>
					</thead>
					<tbody data-testid="readingPlanDayTableBody">
						{
							readingPlanData && readingPlanData.detailItems.map((data: any, index) =>
								<tr key={data.readingPlanId + index} >
									<th scope="row">{data.month}</th>
									<td >{data.day}</td>
									<td data-testid="bibleContainer">
										<Input type="select" key={data.day + "_bibleId" + data.month} className="form-select" id="bibleId" name="bibleId" value={data.bibleId}
											onChange={(event) => {
												handleChangeText(event, data, index, "bibleId"); setSelectedMonth(data.month); setSelectedDay(data.day);
												// Auto save the translation change once a reading is entered
												if (data.readingTitle) { handleReadingSubmit(event, data, index, true); }
											}}
											disabled={data.episodeId > 0 }>
											{bibleList && bibleList.map((data: any) =>
													<option key={data.value} value={data.value}>{data.text}</option>)}
										</Input>
									</td>
									<td >
										<div className="button-wrapper">
											<div data-testid="readingTitleContainer" className="reading-text"
												onClick={() => { if (data.episodeId > 0) { showAlert("Cannot update a reading plan day that has an episode.", true) } }}>
												<EditableDropdown value={data.readingTitle} idValue="title" oldValue={data.readingTitle}
													disable={data.episodeId > 0}
													onChange={(event) => { handleChangeText(event, data, index, "readingTitle"); setSelectedMonth(data.month); setSelectedDay(data.day); }}
													onBlur={(event) => handleReadingSubmit(event, data, index)}
													onSelect={(event) => handleReadingSubmit(event, data, index)}
													suggestions={(data.month === selectedMonth && data.day === selectedDay) ? readingList:[]}
												/>
											</div>
											<div className="reading-actions">
												{/* {data.bibleId > 0 || data.readingTitle ? <FontAwesomeIcon cursor='pointer' size='2x' icon={faFilePen} data-testid="saveReading" data-bs-toggle="tooltip" title="Save" onClick={(event) => handleReadingSubmit(event, data, index)} /> : ""} */}
												{data.readingId > 0 ? <FontAwesomeIcon cursor='pointer' size='2x' icon={faTrashAlt} data-testid="deleteReading" data-bs-toggle="tooltip" title="Delete" onClick={(event) => handleReadingDelete(event, data, index)} /> : ""}
											</div>											
										</div>
									</td>
									<td data-testid="viewReadingButton">
										{data.readingTitle !== null && data.readingId >= 0 && data.readingTitle !== "" && (
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faBookOpen}
												data-bs-toggle="tooltip" data-bs-placement="bottom" title="Open readings" onClick={() => { window.location.href = "/reading?id=" + data.readingId }} />
										)}
										{(data.readingTitle === null || data.readingTitle === "") && (
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faHourglassHalf}
												data-bs-toggle="tooltip" data-bs-placement="bottom" title="readings" onClick={() => { if (data.readingId >= 0) { window.location.href = "/reading?id=" + data.readingId; } }} />
										)}
									</td>
									<td data-testid="episodeButton">
										{data.episodeId > 0 && data.readingId > 0 ?
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faMicrophone} onClick={() => { window.location.href = "/episode?id=" + data.episodeId }}
												data-bs-toggle="tooltip" data-bs-placement="bottom" title="Open Episode" /> :
											data.readingId > 0 && data.episodeId <= 0 ?
												<FontAwesomeIcon cursor='pointer' size='2x' icon={faPlus}
													onClick={() => handleCreateEpisode(data)}
													data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add Episode" /> :
												<FontAwesomeIcon size='2x' icon={faPlus} className="disabled-icon" data-bs-toggle="tooltip" data-bs-placement="bottom" />}
									</td>
								</tr>
							)}
					</tbody>
				</table>

			</div>
			{
				showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
				)
			}

			<Modal isOpen={confirmModal} backdrop="static" centered data-testid="readingModal">
				<ModalHeader className="modal-header" >Reading Title</ModalHeader>
				<ModalBody className="modal-body">This reading has never been used before. Are you sure it's spelled correctly?</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" data-bs-dismiss="modal" onClick={() => setConfirmModal(false)} data-testid="cancelButton">No</Button>
					<Button type="button" color="primary" onClick={handleTranslationSearch} data-testid="confirmButton">Yes</Button>
				</ModalFooter>
			</Modal>
			<ConfirmModal isShowModal={showDeleteModal} deleteMessage={"Are you sure, Do you want to remove this reading? "} modalChange={handleDeleteModal} />
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { readingPlanData, bibleData, readingData } = state;
	return {
		readingPlanData, bibleData, readingData
	};
};

export default connect(mapStateToProps)(ReadingPlanDetail);
